import React, { useEffect } from 'react';
import { Paper, Typography, Button, Box } from '@mui/material';
import { OneRowSkeleton } from './OneRowSkeleton';

export interface ProfileFetchErrorProps {
  onRetry?: () => void;
  resourceLabel?: string;
  failureMessageIntro?: string;
}

export const SkeletonWithRetry: React.FC<ProfileFetchErrorProps> = ({ onRetry, resourceLabel = 'map data',  failureMessageIntro = "We couldn't fetch",}) => {
  useEffect(() => {
    if (!onRetry) return;
    const interval = setInterval(onRetry, 5000 )//* 60 * 1000);
    return () => clearInterval(interval);
  }, [onRetry]);

  return( <OneRowSkeleton/>)

};
